import React from "react";
import { at } from "lodash";
import { useField } from "formik";
import { FormHelperText, InputAdornment, InputLabel, TextField, styled } from "@mui/material";


const StyledTextarea = styled('textarea')({
  resize: 'none',
  borderColor:'#b2b9dc',
  fontSize: '12px',
  fontWeight: '400',
  fontFamily: 'Lato',
  borderRadius: '5px',
  height:'72px',
  "&:focus-visible":{
    outline: 'none'
  },
  "& .MuiInputBase-input.Mui-disabled": {
    WebkitTextFillColor: "#000000",
    padding: "0",
  },
});
const InputField = (props) => {
  const { errorText, label, height, width, isDisabled, type='input', mode, startAdornment, maxLength, reserveHelperSpace = false, helperMinHeight = 18, ...rest } = props;
  const [field, meta,helpers] = useField(props);
  const renderHelperText = () => {
    const [touched, error] = at(meta, "touched", "error");
    if (touched && error) {
      return error;
    }
    return reserveHelperSpace ? ' ' : undefined;
  };
  const handleChange = (event) => {
    let value = event.target.value;

    if (mode === "numeric") {
      value = value.replace(/\D/g, "");
    } else if (mode === "decimal") {
      value = value.replace(/[^0-9.]/g, "");
      const splitValues = value.split(".");
      if (splitValues.length > 2) {
        value = `${splitValues[0]}.${splitValues.slice(1, 2).join("").slice(0, 2)}`;
      } else if (splitValues.length === 2) {
        value = `${splitValues[0]}.${splitValues[1].slice(0, 2)}`;
      }
    }

    helpers.setValue(value);
  };
  return (
    <>
      <InputLabel htmlFor="input" sx={{ height: "14px", marginBottom: "0" }}>
        {label}
      </InputLabel>
      {type !== "textarea" ?
        <TextField
          type={mode || 'text'}
          size="small"
          variant="standard"
          error={meta.touched && meta.error && true}
          helperText={renderHelperText()}
          disabled={isDisabled}
          {...(reserveHelperSpace ? { FormHelperTextProps: { sx: { minHeight: `${helperMinHeight}px`, visibility: (meta.touched && meta.error) ? 'visible' : 'hidden' } } } : {})}
          slotProps={startAdornment && {
            input: {
              startAdornment: <InputAdornment position="start">{startAdornment}</InputAdornment>,
              inputMode: mode === "decimal" ? "decimal" : "numeric",
              pattern: mode === "decimal" ? "[0-9]*[.,]?[0-9]*" : "[0-9]*"
            },
          }}
          sx={{
            '& .MuiInputBase-root': {
              border: "1px solid #b2b9dc",
              borderRadius: "4px",
              '&::before, &::after': {
                borderBottom: 'none !important', 
              },
             '&:hover':{
              '&::before, &::after': {
                borderBottom: 'none', 
              },
             }
            },
            ...(reserveHelperSpace ? { '& .MuiFormHelperText-root': { minHeight: `${helperMinHeight}px` } } : {}),
            "& .MuiInputBase-input.Mui-disabled": {
              WebkitTextFillColor: "#000000",
              padding: "0",
            },
          }}
          inputProps={{
            maxLength: maxLength || undefined,
            style: {
              height: "14px",
              // maxWidth: width || "200px",
              padding: "0",
              fontFamily:'Lato',
            },
          }}
          {...field}
          {...rest}
          onChange={handleChange}
        /> :<>
        <StyledTextarea
          minRows={4}
          sx={{
            height: height || '72px',
            width: width || '325px',
          }}
          type="text"
          size="small"
          variant="standard"
          disabled={isDisabled}
          {...field}
          value={field.value || ''}
        />
        {meta.touched && meta.error && (
          <FormHelperText error>{meta.error}</FormHelperText>
        )}</>
          }
    </>
  );
};

export default React.memo(InputField);
